export const capitalizeFirst = (str: string): string => {
  if (!str || !str?.[0]?.toUpperCase) return str;
  return str[0].toUpperCase() + str.slice(1);
};
